import usersApps from './users-apps';

const route = {
	path: ':idCompany/users',
	name: 'page-user',
	meta: {
		title: 'Usuarios',
	},
	component: () => import('@/pages/users/page-user'),
	props: true,
	children: [
		{
			path: 'new',
			name: 'page-user-new',
			meta: {
				title: 'Nuevo Usuario',
			},
			component: () => import('@/pages/users/page-user-new'),
			props: true,
		},
		{
			path: ':id/edit',
			name: 'page-user-edit',
			meta: {
				title: 'Editar Usuario',
			},
			component: () => import('@/pages/users/page-user-new'),
			props: true,
		},
		{
			path: ':id/change',
			name: 'page-users-change-password',
			meta: {
				title: 'Cambiar Contraseña de Usuario',
			},
			component: () => import('@/pages/users/page-users-change-password'),
			props: true,
		},
		usersApps,
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/users.js